module.exports = __webpack_public_path__ + "media/tips/02_petit_vetement-3a13aa3b.jpg";